import { useNavigate } from 'react-router-dom'
import { TrendingUp } from 'lucide-react'
import { useStatsData } from '../hooks/useStatsData'
import WinRateSparkline from '../components/WinRateSparkline'

const Dashboard = () => {
  const navigate = useNavigate()
  const { data: players, loading, error } = useStatsData()

  if (loading) return <div className="text-center py-8">Loading players...</div>
  if (error) return <div className="text-red-600 text-center py-8">Error: {error}</div>

  const handlePlayerClick = (playerId) => {
    navigate(`/player/${playerId}`)
  }

  return (
    <div>
      <div className="mb-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Select a Player</h1>
        <p className="text-xl text-gray-600">Choose a player to view detailed statistics and trends</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {players?.map(player => (
          <div 
            key={player.player_id}
            onClick={() => handlePlayerClick(player.player_id)}
            className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 p-8 cursor-pointer transform hover:-translate-y-1 border border-gray-100"
          >
            <div className="flex items-center mb-4 w-full gap-4">
              <div className="flex-1 min-w-0">
                <h3 className="text-2xl font-bold text-gray-900 truncate">{player.player_name}</h3>
                <p className="text-gray-600 text-xs truncate">Player ID: {player.player_id}</p>
              </div>
              <div className="flex items-center flex-1 min-w-0 gap-2">
                <div className="text-2xl font-bold text-blue-600 min-w-[56px] text-right">
                  {(player.win_rate.overall * 100).toFixed(1)}%
                </div>
                <div className="flex-1 min-w-0 h-8 flex items-center">
                  <WinRateSparkline data={player.win_rate.trend} />
                </div>
              </div>
            </div>
            <div className="mt-6 text-center">
              <span className="text-blue-600 font-medium hover:text-blue-700">
                View Detailed Statistics →
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Dashboard